import { Component, OnInit, input, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogBaseComponent } from '../../shared/dialogs/dialog-base.component';
import { DialogInformation, DialogInformationService } from '../../products/services/dialog.information.service';

@Component({
  selector: 'app-information-chart-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './information-chart-dialog.component.html',
  styleUrl: './information-chart-dialog.component.scss'
})
export class InformationChartDialogComponent extends DialogBaseComponent implements OnInit {

  readonly dialogInformationService = inject(DialogInformationService);
  @Input() dialogInformationId: string = '';

  dialogInformation: DialogInformation = {
    id: '',
    title: '',
    content: '',
    footer: ''
  }

  ngOnInit(): void {
    this.dialogInformationService.getDialogInformation(this.dialogInformationId).subscribe((result) => {
      this.dialogInformation = result;
    });
  }

}
